import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

export const postPatientDeposit = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/patient-deposits`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getPatientDeposits = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  businessId,
  identity_number = "",
  name = "",
  phone_number = "",
}) => {
  try {
    let link =
      `/lambda/v1/patient-deposits/${businessId}?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);

    if (identity_number) {
      link = link.concat(
        "&identity_number=" + encodeURIComponent(identity_number)
      );
    }
    if (name) {
      link = link.concat("&name=" + encodeURIComponent(name));
    }
    if (phone_number) {
      link = link.concat("&phone_number=" + encodeURIComponent(phone_number));
    }

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getPatientDepositDetail = async (id) => {
  try {
    const response = await axios.get(
      `/lambda/v1/patient-deposits/detail/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const deletePatientDeposit = async (id) => {
  try {
    const response = await axios.delete(
      `/lambda/v1/patient-deposits/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};
